import { surveyResponseDetailStore } from "../stores";

export const useSurveyResponseDetailStore = () => surveyResponseDetailStore;
